//This service is used to fetch various URLs for HIRE Product.
//This depends on $log module in jv.log4javascript.js to log any errors. Ideally this should be present in all the applications.
angular.module('jv.Hire.Url.Service', [])
.factory('jvUrlUtils', function() {
 return  {
/** As $.param replace space character with + ( in jquery 1.7) , use this utility function  */
        param: function(params){
            var s = [];
            for (var key in params ) {
            s.push('{0}={1}'.format(key ,params[key]));
            }
            return s.join( '&' );
        }
  };
})
.factory('jvHireUrlService', ['$window', '$log', '$location','jvUrlUtils', function($window, $log, $location,jvUrlUtils) {
    var isSinglePageApp = true, isCandidateSearchEnabled = true, tabOrderEnabled = false;
    if(angular.isDefined($window.properties)){
        isSinglePageApp = angular.isDefined($window.properties.candidateSinglePageAppEnabled) ? $window.properties.candidateSinglePageAppEnabled : true;
        isCandidateSearchEnabled = angular.isDefined($window.properties.candidateSearchEnabled) ? $window.properties.candidateSearchEnabled : true;
        tabOrderEnabled = $window.properties.candidateTabReorderEnabled;
    }
    return  {
        /**
        Method to fetch the application details URL.
        appId: applicationId (required)
        section: which section to land on. Default will land to first page selected.
        readMode: whether to fetch from master(0) or slave(1).
        */
        getApplicationDetailsUrl: function(appId, master, section) {
            var readMode = 1, baseUrl, params = {
                mode: 'paginate'
            };
            if (appId == null) {
                $log.error('appId is required for application details');
                return;
            }
            if (!section) {
                section = 'profile';
            }

            if (master === true) {
                readMode = 0;
                params.readMode = 0;
            }
            if(isSinglePageApp){
                baseUrl = $window.jvUrls.jhire+'/modules/candidates/search.html?{0}'.format($.param(params));
            } else{
                baseUrl = $window.jvUrls.jhire+'/modules/candidates/details.html?readMode={0}&applicationId={1}&mode=paginate'.format(readMode,appId);
            }
            return '{0}#/{1}/{2}'.format(baseUrl,section,appId);
        },
        getApplicationDetailsDefaultTabUrl:function(appEId, master){
            if(isSinglePageApp){
                if($window.location.href.indexOf('/search.html')>=0){
                    return (tabOrderEnabled ? '#/profile/{0}' : '#/summary/{0}').format(appEId);
                }
            }
            return this.getApplicationDetailsUrl(appEId,master,tabOrderEnabled ? 'profile' : 'summary');
        },
        /**
        Method to fetch the requisition details URL.
        reqId: RequsitionID (required)
        */
        getRequisitionDetailsUrl: function(reqId) {
            if (reqId == null) {
                $log.error('Requisition Id is required for requsition details');
                return;
            }
            return $window.jvUrls.jhire + '/modules/requisitions/tabs.html#/summary/{0}'.format(reqId);
        },
        navigateToCandidateDetails: function(appId, section){
            if(isSinglePageApp){
                $location.path('/{0}/{1}'.format(section, appId));
            }else{
                $window.location.href = this.getApplicationDetailsUrl(appId, false, section, false);
            }
        },
        navigateToCandidateScheduler: function(appId, stateId){
            var url = $window.jvUrls.jhire;
            if(isSinglePageApp){
                url = '/workflow-scheduler/{0}/{1}/mode/schedule'.format(appId, stateId);
                $location.path(url);
            }else{
                url += '/modules/candidates/details.html?applicationId={0}&mode=paginate&type=schedule#/workflow-scheduler/{0}/{1}/mode/schedule'.format(appId, stateId);
                $window.location.href =  url;
            }
            return url;
        },
        navigateToCandidateSelfScheduler: function(appId, stateId, jobId){
            var url = $window.jvUrls.jhire;
            url = $window.jvUrls.jhire + '/modules/candidates/details/workflow/advancedScheduler.html?appid={0}&wfsid={1}&jobid={2}#/interviewInformation'.format(appId,stateId,jobId);
            $window.location.href = url;
            return url;
        },
        getApplicationDetailsUrlWithTab: function(appId, params, hash){
            var url = $window.jvUrls.jhire;
            url += isSinglePageApp ? '/modules/candidates/search.html?{0}#/{1}'.format($.param(params),hash) : '/modules/candidates/details.html?applicationId={0}&{1}#/{2}'.format(appId,$.param(params),hash);
            return url;
        },
        reloadCandidateDetails: function(url){
            $location.path(url);
        },
        loadCandidateDetailsTab: function(tab, appId){
            $location.path('{0}/{1}'.format(tab,appId), !isSinglePageApp);
        },
        loadCandidateDetailsTabByLink: function(href){
            $location.path(href, !isSinglePageApp);
        },
        navigateToCandidateSmartScheduler: function(params, hash){
            return '{0}/modules/candidates/details/workflow/advancedScheduler.html?{1}#{2}'.format($window.jvUrls.jhire, $.param(params),hash);
        },
        getCandidateListPageUrl: function(params){
            var url = '';
            if(isCandidateSearchEnabled){
                url = $window.jvUrls.jhire + '/modules/candidates/search.html';
                if(angular.isDefined(params)){
                    url += '#/?{0}'.format(jvUrlUtils.param(params));
                }
            }else{
                url = $window.jvUrls.source + '/person/applicants.html';
                if(angular.isDefined(params)){
                    url += '?{0}'.format(jvUrlUtils.param(params));
                }
            }
            return url;
        },
        openJVIMFloatingWidget: function(candidateEId) {
            if(window.canvasRecruiterMiddleware){
                //added check for JVIM if initalized by candidate EID
                window.isIMInitializedByEId = true;
                window.canvasRecruiterMiddleware.syncCandidateData({
                    atsRefKey: 'candidate|'+candidateEId
                });
            }
        }
    };
}]);